<template>
  <div class="logos">
    <div class="column">
      <img class="logo" :src="iconPaths.bb1"/>
      <div class="game-name">Линии 1</div>
    </div>
    <div class="column">
      <img class="logo" :src="iconPaths.nb1"/>
      <div class="game-name">Бой 1</div>
    </div>
    <div class="column column-nominal">
      <div class="game-name game-name-nominal">Номинал</div>
    </div>
    <div class="column">
      <img class="logo" :src="iconPaths.nb2"/>
      <div class="game-name">Бой 2</div>
    </div>
    <div class="column">
      <img class="logo" :src="iconPaths.bb2"/>
      <div class="game-name">Линии 2</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RuLogos',
  computed: {
    iconPaths() {
      return {
        bb1: require(`@/assets/images/RU/label-mc-bb1.png`),
        bb2: require(`@/assets/images/RU/label-mc-bb2.png`),
        nb1: require(`@/assets/images/RU/label-mc-nb1.png`),
        nb2: require(`@/assets/images/RU/label-mc-nb2.png`),
      };
    },
  },
};
</script>

<style scoped>
.logos {
  display: inline-flex;
  margin-bottom: 6px;
}

.logo {
  display: block;
  max-width: 100%;
}

.column {
  margin: 0 4px 0 0;
  align-content: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.game-name {
  position: relative;
  margin-top: -44px;
  z-index: 1;
  width: 206px;
  height: 60px;
  border-radius: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.04);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  font-family: 'ONY One', serif;
  font-weight: 500;
  font-size: 28px;
  line-height: 100%;
  text-align: center;
  color: #FFFFFFCC;
}

.game-name-nominal {
  width: 100%;
}

.column-nominal {
  padding-top: 150px;
  width: 260px;
}
</style>
